import Amplify from '@aws-amplify/core';
import { ROUTES, SIGNED_OUT_QUERY_PARAM } from '../../constants';
import ServiceUrl from '../ServiceUrl';

export const get = () => {
  const {
    REACT_APP_PROTOCOL,
    REACT_APP_IDENTITY_POOL_ID,
    REACT_APP_AWS_REGION,
    REACT_APP_USER_POOL_ID,
    REACT_APP_USER_POOL_CLIENT,
    REACT_APP_USER_POOL_DOMAIN,
    REACT_APP_USER_STATE_API,
  } = process.env;

  const PROTOCOL = REACT_APP_PROTOCOL || 'https:';
  const { host } = window.location;

  return {
    Auth: {
      identityPoolId: REACT_APP_IDENTITY_POOL_ID,
      region: REACT_APP_AWS_REGION,
      userPoolId: REACT_APP_USER_POOL_ID,
      userPoolWebClientId: REACT_APP_USER_POOL_CLIENT,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      mandatorySignIn: true,
      oauth: {
        domain: REACT_APP_USER_POOL_DOMAIN,
        scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: `${PROTOCOL}//${host}${ROUTES.SOCIAL_AUTH_REDIRECT}`,
        redirectSignOut: `${PROTOCOL}//${host}${ROUTES.SIGN_IN}?${SIGNED_OUT_QUERY_PARAM}`,
        responseType: 'code',
        options: {
          AdvancedSecurityDataCollectionFlag: false,
        },
      },
    },
    API: {
      endpoints: [
        {
          name: 'MarketingPreferences',
          endpoint: ServiceUrl.public('communication-preferences'),
          region: REACT_APP_AWS_REGION,
          service: 'execute-api',
        },
      ],
      aws_appsync_graphqlEndpoint: REACT_APP_USER_STATE_API,
      aws_appsync_region: REACT_APP_AWS_REGION,
      aws_appsync_authenticationType: 'AWS_IAM',
    },
  };
};

export const setup = () => Amplify.configure(get());

export default {
  get,
  setup,
};
